import { Component, OnInit, Input } from '@angular/core';
import { Validators, UntypedFormBuilder } from '@angular/forms';
import { AppConstants } from 'src/app/app.constants';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';


@Component({
  selector: 'app-change-plan-owner',
  templateUrl: './change-plan-owner.component.html',
  styleUrls: ['./change-plan-owner.component.css']
})

export class ChangePlanOwnerComponent implements OnInit {
  @Input() set selectedPlan(value: any) {
    this._selectedPlan = value;
  }
  @Input() set selectedPlanMonthlyPrice(value: any) {
    this._selectedPlanMonthlyPrice = value;
  }
  @Input() set plans(value: any) {
    this._plans = value;
  }
  
  constructor(
    private formBuilder: UntypedFormBuilder,
    public functionsService: FunctionsService,
    public activeModal: NgbActiveModal,
    private apiService: ApiService,
    public constant: AppConstants) { }

  _selectedPlan: any;
  _selectedPlanMonthlyPrice: any;
  _plans: any;

  formSubmitted: boolean = false;

  editAccountForm = this.formBuilder.group({
    planId: ['', Validators.required]
  });
  
  ngOnInit() { 
    document.getElementById("cart-updated").hidden = true;
  }

  savePlan(selectedPlan){
      this.apiService.updateCart({"PlanId":selectedPlan}).subscribe(
          () => {
            let element: HTMLElement = document.getElementById("cart-updated") as HTMLElement;
            element.click();
            this.apiService.getAgentDispatch().subscribe(result => {
                localStorage.setItem('agentDispatch', result['agentDispatch']);
                localStorage.setItem('geoAssignment', result['geoAssignment']);
            });
            this.activeModal.close();
          },
          error => {
            this.functionsService.errorHandler(error["status"]);
          }
      );
  }

  get planId() { return this.controlGetter('Id'); }

  controlGetter(controlName) {
    const control =  this.editAccountForm.get(controlName);
    return control && (control.touched || this.formSubmitted) ? control : {};
  }
}
